import { LAYOUT_OBJECT_MIN_SIZE } from '../../../../../../constants';

// Structural copy of the Konva transformer box. The shipped konva typings are
// unusable here — the deep import resolves `Box` without its IRect members
// (their .d.ts imports carry .ts extensions) and TransformerConfig degrades to
// unknown — so the shape is declared locally.
type TransformerBox = {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
};

type TransformerBoxParams = {
  oldBox: TransformerBox;
  newBox: TransformerBox;
  scaleX: number;
  scaleY: number;
};

// Guards only the box size (shrink-below-minimum and flip) — canvas bounds
// are deliberately NOT checked here. The box is the node's client rect
// including the selection decorations, so an object flush against a canvas
// edge always has its box outside the canvas; any live bounds enforcement
// (rejecting or clamping the box) then freezes the whole resize (JS-1248).
// The geometry is pulled back into the canvas on transform end instead.
export const resolveTransformerBox = ({
  oldBox,
  newBox,
  scaleX,
  scaleY,
}: TransformerBoxParams): TransformerBox => {
  const hasInvalidSize =
    newBox.width < LAYOUT_OBJECT_MIN_SIZE * scaleX ||
    newBox.height < LAYOUT_OBJECT_MIN_SIZE * scaleY;

  return hasInvalidSize ? oldBox : newBox;
};
